import React from 'react';
import Immutable from 'immutable';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { Route, Switch } from 'react-router';
import config from 'react-global-configuration';

import {
  EntityMapperContext,
  I18nProvider,
} from '@uncinc/react-drupal-core';
import i18next from '../../config/i18next';

import Search from '../Search';

import blocksMapper from '../../mappers/blocks';
import nodeMapper from '../../mappers/node';
import paragraphMapper from '../../mappers/paragraphs';
import taxonomyMapper from '../../mappers/taxonomy';
import viewsMapper from '../../mappers/views';

import Header from '../../components/Header';
import CampaignPageHeader from '../../components/CampaignPageHeader';
import Footer from '../../components/Footer';
import Entity from '../Entity';
import CustomRoute from '../CustomRoute/index';

import '../../styles/main.scss';
import './style.scss';

const App = () => {
  const entityId = useSelector((state) => state.getIn(['entity', 'entityId'], null));
  const entityType = useSelector((state) => state.getIn(['entity', 'entityType'], null));
  const childEntity = useSelector((state) => state.getIn([entityType, entityId], Immutable.Map()));
  const rootClasses = useSelector((state) => state.getIn(['ui', 'rootClasses']));
  const entityExists = useSelector((state) => state.getIn(['entity', 'exists']));
  const language = useSelector((state) => state.getIn(['ui', 'language']));

  const currentEntityId = useSelector((state) => state.getIn(['entity', 'entityId'], null));

  // Either check if we have a current Node, or as a fallback, a TaxonomyTerm
  const currentNodeType = useSelector((state) => state.getIn(['node', currentEntityId, 'type', 0, 'target_id']));
  const currentTaxonomyType = useSelector((state) => state.getIn(['taxonomyTerm', currentEntityId, 'vid', 0, 'target_id']));

  const isCampaignPage = currentNodeType === 'campaign_page';
  const isCampaignPage2 = currentNodeType === 'campaign_page_2';
  const isHomepageTakeover = currentNodeType === 'home_page_takeover';

  const classes = classNames('App', rootClasses.join(' '), {
    'is-front-page': childEntity.get('is_front'),
    'not-found': !entityExists,
  });

  const entityTypeMapper = {
    block: blocksMapper,
    node: nodeMapper,
    paragraph: paragraphMapper,
    taxonomy: taxonomyMapper,
    view: viewsMapper,
  };

  return (
    <EntityMapperContext.Provider value={entityTypeMapper}>
      <I18nProvider locale={language} i18next={i18next}>
        <div className={classes} language={language}>
          {(currentNodeType !== undefined) && isCampaignPage && (
            <CampaignPageHeader />
          )}
          {(
            ((currentNodeType !== undefined) || (currentTaxonomyType !== undefined)) &&
            !isCampaignPage &&
            !isCampaignPage2 &&
            !isHomepageTakeover) &&
            (
              <Header />
            )}
          <main className="main">
            <Switch>
              <CustomRoute path="/:language/:path(zoeken|search)" render={() => (<Search />)} />
              <Route render={() => (<Entity />)} />
            </Switch>
          </main>
          <Footer />
        </div>
      </I18nProvider>
    </EntityMapperContext.Provider>
  );
};

export default App;
